const SET_SCHEDULE_PROPERTY = 'SET_SCHEDULE_PROPERTY';
const SAVE_SCHEDULE = 'SAVE_SCHEDULE';
const GET_SCHEDULE = 'GET_SCHEDULE'
const SET_SCHEDULE_RECORDS = 'SET_SCHEDULE_RECORDS'
const SET_SCHEDULE_PAGINATION ='SET_SCHEDULE_PAGINATION'
const UPDATE_SCHEDULE_STATUS = 'UPDATE_SCHEDULE_STATUS';
const SET_SCHEDULE_STATUS = 'SET_SCHEDULE_STATUS'
const SEARCH_SCHEDULE = 'SEARCH_SCHEDULE'
const SET_SCHEDULE_FILTERS = 'SET_SCHEDULE_FILTERS'
const UPDATE_SCHEDULE_CONFIG = 'UPDATE_SCHEDULE_CONFIG'
const REMOVE_SCHEDULE_CONFIG = 'REMOVE_SCHEDULE_CONFIG'
const EXPORT_SCHEDULE_CONFIGS = 'EXPORT_SCHEDULE_CONFIGS'

const setScheduleProperty = (data)=>{
    return {
        type: SET_SCHEDULE_PROPERTY,
        data
    }
}
const setScheduleStatus = data =>{
    return {
        type:SET_SCHEDULE_STATUS,
        data
    }
}
const updateScheduleStatus = data =>{
    return {
        type:UPDATE_SCHEDULE_STATUS,
        data
    }

}

const saveSchedule = payload =>{
    return {
        type: SAVE_SCHEDULE,
        payload
    }
}

const getSchedule = query =>{
    return {
        type: GET_SCHEDULE,
        query
    }
}

const setScheduleRecords = records =>{
    return{
        type:SET_SCHEDULE_RECORDS,
        records
    }
}

const setPaginationSchedule = pagination =>{
    return {
        type:SET_SCHEDULE_PAGINATION,
        pagination
    }
}

// query = {page, perPage}; los filtros se toman del estado (scheduleFilters)
const searchSchedule = query =>{
    return {
        type: SEARCH_SCHEDULE,
        query
    }
}

const setScheduleFilters = filters =>{
    return {
        type: SET_SCHEDULE_FILTERS,
        filters
    }
}

// payload = {taxId, documentType, processType, changes}
const updateScheduleConfig = payload =>{
    return {
        type: UPDATE_SCHEDULE_CONFIG,
        payload
    }
}

// payload = {taxId, documentType, processType}
const removeScheduleConfig = payload =>{
    return {
        type: REMOVE_SCHEDULE_CONFIG,
        payload
    }
}

const exportScheduleConfigs = () =>{
    return {
        type: EXPORT_SCHEDULE_CONFIGS
    }
}


export default {
    types:{
        SET_SCHEDULE_PROPERTY,
        SAVE_SCHEDULE,
        GET_SCHEDULE,
        SET_SCHEDULE_RECORDS,
        SET_SCHEDULE_PAGINATION,
        UPDATE_SCHEDULE_STATUS,
        SET_SCHEDULE_STATUS,
        SEARCH_SCHEDULE,
        SET_SCHEDULE_FILTERS,
        UPDATE_SCHEDULE_CONFIG,
        REMOVE_SCHEDULE_CONFIG,
        EXPORT_SCHEDULE_CONFIGS
    },
    actions:{
        setScheduleProperty,
        saveSchedule,
        getSchedule,
        setScheduleRecords,
        setPaginationSchedule,
        updateScheduleStatus,
        setScheduleStatus,
        searchSchedule,
        setScheduleFilters,
        updateScheduleConfig,
        removeScheduleConfig,
        exportScheduleConfigs
    }
}